import { OutlookCalendarActions } from './actions'
import { OutlookCalendarGetters } from './getters'
import { OutlookCalendarMutations } from './mutations'
import { OutlookCalendarState } from './state'

export const OUTLOOK_CALENDAR_NAMESPACE = 'outlookCalendar'

export const OutlookCalendar = {
  actions: OutlookCalendarActions,
  getters: OutlookCalendarGetters,
  mutations: OutlookCalendarMutations,
  namespaced: true,
  state: OutlookCalendarState,
}
